const Tabs = ({ tabs, onChange, value }) => {
  const renderTabContent = () => {
    const currentTab = tabs.find((tab) => tab.id === value);
    return currentTab ? currentTab.component : null;
  };

  return (
    <div className="w-full border-b border-gray-200">
      <div className="flex w-full justify-between">
        <nav className="flex w-full mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onChange(tab.id)}
              className={`inline-flex w-full text-center justify-center items-center border-b-2 p-4 text-sm font-medium ${
                value === tab.id
                  ? "border-[#215759] text-[#215759]"
                  : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
              }`}
            >
              {tab.label}
              {tab.count !== null && (
                <span
                  className={`ml-2 rounded-full px-2.5 py-0.5 text-xs font-medium ${
                    value === tab.id
                      ? "bg-[#215759]/10 text-[#215759]"
                      : "bg-gray-100 text-gray-600"
                  }`}
                >
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>
      <div className="mt-[-1px] h-0.5 w-full bg-gray-200"></div>
      {renderTabContent()}
    </div>
  );
};

export default Tabs;
